import { render, staticRenderFns } from "./image-input.vue?vue&type=template&id=4339f067"
import script from "./image-input.vue?vue&type=script&lang=js"
export * from "./image-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports